module.exports = __webpack_public_path__ + "img/pcBanner15.029dd304.png";